import { createUseStyles } from 'react-jss'
import { colors } from 'components/common'

const useFilenameStyles = createUseStyles({
  filenameWrapper: {
    '& > .icon': {
      marginRight: '1rem',
      color: 'inherit',
      transition: 'none',
      transform: 'translate(0, -1px)'
    },

    '&.clickable > .filename:hover': {
      cursor: 'pointer',
      textDecoration: 'underline'
    },

    '& > .filename.ascend-selector': {
      fontSize: 16,
      letterSpacing: '1px'
    }
  }
})

const usePathLocationStyles = createUseStyles({
  pathLocationWrapper: {
    padding: '0.75rem',
    backgroundColor: colors.gray50,
    border: '1px solid rgba(0,0,0,0.1)',
    borderTopLeftRadius: 4,
    borderTopRightRadius: 4,

    '& .path-separator': {
      margin: '0 0.25rem',
      color: colors.gray300
    },

    '& .path-location-segment.root': {
      fontSize: 16,
      padding: '0 0.25rem'
    },

    '& .path-location-segment:hover:not(.active)': {
      color: colors.theme500,
      cursor: 'pointer'
    },

    '& .path-location-segment.active': {
      fontWeight: 'bold',
      color: colors.theme500
    }
  }
})

export { useFilenameStyles, usePathLocationStyles }
